import React, { forwardRef } from 'react';
import { Button, type ButtonProps, Typography } from '@mui/material';
import { colors } from '../../tokens';
import useAIDTMediaQuery from '../../hooks/useAIDTMediaQuery';

export interface EliceSubButtonProps extends ButtonProps {
  children?: React.ReactNode;
}

const EliceSubButton = forwardRef<HTMLButtonElement, EliceSubButtonProps>(
  ({ children, variant = 'contained', disabled, ...rest }, ref) => {
    const { isTablet } = useAIDTMediaQuery();

    return (
      <Button
        ref={ref}
        variant={variant}
        disabled={disabled}
        sx={{
          width: isTablet ? '100%' : 'fit-content',
          height: '52px',
          borderRadius: isTablet ? 0 : '16px',
          padding: '8px 12px',
          backgroundColor: colors.bluepurple[100],
          fontFamily: 'inherit',
          display: 'flex',
          justifyContent: 'flex-start',
        }}
        {...rest}
      >
        <Typography variant="buttoninput" sx={{ color: `${colors.bluepurple[950]} !important` }}>
          {children}
        </Typography>
      </Button>
    );
  }
);

export default EliceSubButton;
